import {
  ASSET_REGISTER_REPORT,
  ASSIGNMENT_HISTORY_REPORT,
  COST_SUMMARY_REPORT,
  DEPARTMENT_WISE_REPORT,
  LOCATION_WISE_REPORT,
  REPAIR_HISTORY_REPORT,
  REPORTS,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// Parent path must be a real prefix of every child's absolute path (react-router v6
// throws "Absolute route path ... nested under path ... is not valid" otherwise) — use
// REPORTS ('/report'), NOT one of the sibling report paths, as the parent link.
export const ReportRoutes: IAppRoutes = {
  link: REPORTS,
  childrens: [
    {
      link: ASSET_REGISTER_REPORT,
      element: guard(() => import('@modules/report/AssetRegister'), [ASSET_REGISTER_REPORT]),
    },
    {
      link: ASSIGNMENT_HISTORY_REPORT,
      element: guard(() => import('@modules/report/AssignmentHistory'), [ASSIGNMENT_HISTORY_REPORT]),
    },
    {
      link: REPAIR_HISTORY_REPORT,
      element: guard(() => import('@modules/report/RepairHistory'), [REPAIR_HISTORY_REPORT]),
    },
    {
      link: DEPARTMENT_WISE_REPORT,
      element: guard(() => import('@modules/report/DepartmentWise'), [DEPARTMENT_WISE_REPORT]),
    },
    {
      link: LOCATION_WISE_REPORT,
      element: guard(() => import('@modules/report/LocationWise'), [LOCATION_WISE_REPORT]),
    },
    {
      link: COST_SUMMARY_REPORT,
      element: guard(() => import('@modules/report/CostSummary'), [COST_SUMMARY_REPORT]),
    },
  ],
}
